import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-180757b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-logs-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-title" }, "Get request logs", -1))
const _hoisted_3 = { class: "filter-section" }
const _hoisted_4 = { class: "log-date-header" }
const _hoisted_5 = { class: "log-count" }
const _hoisted_6 = { class: "log-table-container" }
const _hoisted_7 = { class: "log-table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { width: "40%" }, "Message"),
    /*#__PURE__*/_createElementVNode("th", { width: "60%" }, "Data")
  ])
], -1))
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "message-content" }
const _hoisted_11 = { class: "timestamp" }
const _hoisted_12 = { class: "message-text" }
const _hoisted_13 = { class: "data-cell" }
const _hoisted_14 = {
  key: 0,
  class: "json-container"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "json-editor-wrapper"
}
const _hoisted_17 = {
  key: 1,
  class: "no-data"
}
const _hoisted_18 = {
  key: 1,
  class: "no-logs-message"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No logs found for the selected period", -1))
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_json_editor_vue = _resolveComponent("json-editor-vue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_base_input, {
        id: "fromdate",
        label: "From date (optional)",
        type: "date",
        modelValue: _ctx.fromDate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fromDate) = $event)),
        class: "date-picker"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_base_input, {
        id: "requestId",
        label: "Work order number (optional)",
        type: "text",
        modelValue: _ctx.requestId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestId) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_base_button, {
        onClick: _ctx.getLogs,
        text: "Get logs",
        class: "btn-primary"
      }, null, 8, ["onClick"])
    ]),
    (_ctx.apiResponse && _ctx.apiResponse.length > 0)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.apiResponse, (group, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "log-group"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.formatDate(group[0].loggedOnDate)), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(group.length) + " events", 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (row) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.loggedOnDate,
                      class: _normalizeClass({
                  'row-error': row.level === 'Error',
                  'row-warning': row.level === 'Warning',
                  'row-info': row.level === 'Info' || !row.level
                })
                    }, [
                      _createElementVNode("td", {
                        class: "message-cell",
                        title: row.message + '\n' + row.additionalInfo
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.formatTime(row.loggedOnDate)), 1),
                          _createElementVNode("span", _hoisted_12, _toDisplayString(row.message), 1)
                        ])
                      ], 8, _hoisted_9),
                      _createElementVNode("td", _hoisted_13, [
                        (row.contextData)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (_ctx.toggleExpand(row)),
                                class: "toggle-btn"
                              }, _toDisplayString(_ctx.isExpanded(row) ? '▼' : '►') + " " + _toDisplayString(_ctx.getDataSummary(row.contextData)), 9, _hoisted_15),
                              (_ctx.isExpanded(row))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createVNode(_component_json_editor_vue, _mergeProps({
                                      "model-value": row.contextData
                                    }, { readOnly: true, mainMenuBar: false, navigationBar: false }), null, 16, ["model-value"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, "No data"))
                      ])
                    ], 2))
                  }), 128))
                ])
              ])
            ])
          ]))
        }), 128))
      : (_ctx.apiResponse)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
        : _createCommentVNode("", true)
  ]))
}